<template>
    <!-- Header Section -->
    <div class="row wrapper border-bottom white-bg page-heading">
        <!-- Title on the left -->
        <div class="col-lg-8 align-self-center">
            <h2 class="mb-0">eCRF View</h2>
        </div>
        <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
      <i class="fa fa-times close" @click="onclosed()"></i>
      <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="row mb-2">
            <div  :class="ecrfdata.sourceLanguage != 'en' ? 'col-lg-6 px-1' : 'col-lg-12 px-1'">
               <div class="ibox mb-2">
                    <div class="ibox-title style_2 d-flex justify-content-between align-items-center constheight">
                        <div class="d-flex flex-column">
                          <h4>{{ fromdata.formName }} (Source Data)</h4>
                          <small>Language: {{ sourceLanguage }}</small>
                        </div>
                    </div>
                    <div class="ibox-content contentheight">
                        <!-- Form Field Section -->
                        <div class="max-h-400" v-for="eachfields in crfdata" :key="eachfields.fieldName">
                            <div class="card d-flex justify-content-between gap-1 form-field-card px-3 py-0" :class="headderclass(eachfields.type)">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0"> <small> <span> {{ eachfields.label }}</span></small></h6>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p v-if="!novaluearray.includes(eachfields.type)" class="text-muted mb-0">Value: <span> {{gevalue(eachfields)}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="ecrfdata.sourceLanguage != 'en'" class="col-lg-6 px-1">
               <div class="ibox mb-2">
                    <div class="ibox-title style_2 d-flex justify-content-between align-items-center constheight">
                      <div class="d-flex col-md-10 flex-column">
                          <h4>{{ fromdata.formName }} (Translated Data)</h4>
                          <small>Language: {{ targetLanguage }}</small>
                          <!-- <h5 class="mb-0">Randomization Form - <small class="ml-2"> v1.0</small></h5> -->
                      </div>
                      <div class=" d-flex justify-content-end py-1">
                        <button 
                          v-if="fromdata.pages[0].pageStatus !==  'Validated'" 
                          @click.prevent="onformsave()"
                          class="btn btn-sm btn-primary py-0 mr-4">
                            <small> Validate Form</small>
                        </button>
                        <button
                          v-else
                          class="btn btn-sm btn-success py-0 mr-4"
                          disabled>
                           <small> Validated</small>
                      </button>
                      </div>
                    </div>
                    <div class="ibox-content contentheight">
                        <!-- Form Field Section -->
                        <div class="max-h-400" v-for="eachfields in crfformdata" :key="eachfields.fieldName">
                            <div class="card d-flex justify-content-between gap-1 form-field-card px-3 py-0" :class="headderclass(eachfields.type)">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0"> <small> <span> {{ eachfields.label }}</span></small></h6>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p v-if="!novaluearray.includes(eachfields.type)" class="text-muted mb-0">Value: <span> {{gevalue(eachfields)}}</span></p>
                      
                                    <div v-if="!novaluearray.includes(eachfields.type)" class="d-flex justify-content-between-end gap-1">
                                        <!-- <button class="btn btn-sm btn-outline-primary ms-2 py-0" @click="openeditcheckpopup(eachfields.fieldName)"><i
                                                class="fa fa-eye me-1"></i> Edit Check</button>-->
                                                <button class="btn btn-sm btn-primary ms-2 py-0 mb-1" @click="editfieldfun(eachfields)"><i
                                                class="fa fa-edit me-1"></i> Edit</button> 
                                      
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <customModal
      v-if="editpopup"
      :containermd="true"
      @closeModal="Closeeditmodel"
    >
    
 <template #title>
      {{ $t?.('navigations.data verification') || 'Data Verification' }}
    </template>
  <!-- <template #title>
    <div class="titleclass d-flex justify-content-between align-items-center w-100 py-0">
      <h4 class="ml-lg-2 mb-0">{{ $t?.('navigations.data verification') || 'Data Verification' }}</h4>
    </div>
  </template> -->

  <template #body>
    <div class="modalqueryicons d-flex justify-content-end">
        <button
          v-if="roleprivileges.includes('Data Verification Open queries')"
          class="btn btn-danger mr-1 tooltipvisibility"
          type="button"
          @click="FieldQueryDetails('Open')"
        >
          <img src="../../assets/images/open_query.png" alt="" />
          <span class="badge">{{ openQueryCount }}</span>
          <span class="pointer">
            {{ $t?.('navigations.open queries') || 'Open queries' }} ({{ openQueryCount }})
          </span>
        </button>

        <button
          v-if="roleprivileges.includes('Data Verification Closed queries')"
          class="btn btn-info mr-3 tooltipvisibility"
          type="button"
          @click="FieldQueryDetails('Closed')"
        >
          <img src="../../assets/images/closed_query.png" alt="" />
          <span class="badge">{{ closeQueryCount }}</span>
          <span class="pointer">
            {{ $t?.('navigations.closed queries') || 'Closed queries' }} ({{ closeQueryCount }})
          </span>
        </button>

       
      </div>
    <div id="wrapper">
      
      <div class="wrapper wrapper-content animated fadeInRight">
        <div class="row">
          <div class="col-lg-12">
            <div class="ibox ibox-body p-3">
              <div class="ibox-content">
                <p class="mb-2">{{ modelelement.label }}</p>
              </div>

              <div class="form-group row my-3">
                <!-- Field name -->
                <label class="col-md-2 col-form-label my-1">
                  {{ $t?.('navigations.field name') || 'Field name' }}
                </label>
                <div class="col-md-10 my-1">
                  <label class="form-control">{{ modelname }}</label>
                </div>

                <!-- Field value -->
                <label class="col-md-2 col-form-label my-1">
                  {{ $t?.('navigations.field value') || 'Field value' }}
                </label>

                <!-- simple input types -->
                <div v-if="inputElements.includes(modeltype)" class="col-md-10 my-1">
                  <input
                    :disabled="modelprivileges === 'View'"
                    :type="modelelement.type || 'text'"
                    :class="modelinputclass"
                    placeholder="textbox"
                    v-model="modelvalue"
                  />
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- time -->
                <div v-if="modeltype === 'time'" class="col-md-10 my-1">
                  <basetime
                    :disabled="modelprivileges === 'View'"
                    v-model="modelvalue"
                    :dateFormat="gettimeformat(validatevalidationarray)"
                    label=""
                    type="text"
                  />
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- date -->
                <div v-if="modeltype === 'date'" class="col-md-10 my-1">
                  <basedate
                    :disabled="modelprivileges === 'View'"
                    v-model="modelvalue"
                    :dateFormat="getdateformat(validatevalidationarray)"
                    label=""
                    type="text"
                  />
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- date and time -->
                <div v-if="modeltype === 'dateandtime'" class="col-md-10 my-1">
                  <input
                    :disabled="modelprivileges === 'View'"
                    :class="modelinputclass"
                    type="datetime-local"
                    max="9999-12-31"
                    v-model="modelvalue"
                  />
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- number and date -->
                <div v-if="modeltype === 'numberanddate'" class="col-md-10 my-1">
                  <div class="twoitemflex">
                    <input
                      :disabled="modelprivileges === 'View'"
                      type="number"
                      :class="modelinputclass"
                      placeholder="Number"
                      v-model="numberVal"
                    />
                    <input
                      :disabled="modelprivileges === 'View'"
                      type="date"
                      :class="modelinputclass"
                      placeholder="Date"
                      max="9999-12-31"
                      v-model="dateVal"
                    />
                  </div>
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- dropdown -->
                <div v-if="modeltype === 'dropdown'" class="col-md-10 my-1">
                  <select
                    :disabled="modelprivileges === 'View'"
                    class="form-control m-b"
                    v-model="modelvalue"
                  >
                    <option
                      v-for="opt in (modelelement.options || [])"
                      :key="opt.codevalue || opt.optionname"
                      :value="opt.codevalue"
                    >
                      {{ opt.optionname }}
                    </option>
                  </select>
                  <span class="errormsg">{{ errormsg[modelname] }}</span>
                </div>

                <!-- radio -->
                <div v-if="modeltype === 'radio'" :class="modelradioclass">
                  <div>
                    <div
                      v-for="radoptions in (modelelement.options || [])"
                      :key="radoptions.codevalue || radoptions.optionname"
                    >
                      <input
                        :disabled="modelprivileges === 'View'"
                        type="radio"
                        class="form-check-label"
                        :id="radoptions.codevalue"
                        :name="modelelement.fieldName"
                        :value="radoptions.codevalue"
                        v-model="modelvalue"
                      />
                      {{ radoptions.optionname }}
                    </div>
                  </div>
                </div>
                <span v-if="modeltype === 'radio'" class="errormsg radioerror">
                  {{ errormsg[modelname] }}
                </span>

                <!-- year -->
                <div v-if="modelelement.type === 'year'" class="col-md-10 my-1">
                  <input
                    :disabled="modelprivileges === 'View'"
                    class="form-control"
                    type="number"
                    min="1900"
                    max="2099"
                    step="1"
                    :class="modelinputclass"
                    v-model="modelvalue"
                  />
                </div>

                <!-- image (text url) -->
                <div v-if="modelelement.type === 'image'" class="col-md-10 my-1">
                  <input
                    :disabled="modelprivileges === 'View'"
                    class="form-control"
                    type="text"
                    :class="modelinputclass"
                    v-model="modelvalue"
                  />
                </div>

                <!-- scale -->
                <div v-if="modelelement.type === 'scales'" class="col-md-10 my-1">
                  <input
                    :disabled="modelprivileges === 'View'"
                    type="range"
                    :min="scalevlidatemin"
                    :max="scalevalidatemax"
                    step="1"
                    class="col-md-12"
                    v-model="modelvalue"
                  />
                  <input
                    :disabled="modelprivileges === 'View'"
                    type="number"
                    :min="scalevlidatemin"
                    :max="scalevalidatemax"
                    :class="modelinputclass"
                    v-model="modelvalue"
                  />
                </div>

                <!-- textarea/description -->
                <div
                  v-if="['description','textarea','summary'].includes(modelelement.type)"
                  :class="modelradioclass"
                >
                  <textarea
                    :disabled="modelprivileges === 'View'"
                    class="textbox"
                    v-model="modelvalue"
                  />
                </div>

                <!-- upload file (stub UI) -->
                <div v-if="modelelement.type === 'uploadfile'" :class="modelradioclass">
                  <div class="fileuploadbtm d-flex">
                    <div class="col-md-10 d-flex">
                      <h6>{{ downloadedfilenames[modelelement.fieldName] }}</h6>
                    </div>
                  </div>
                  <div class="col-md-10 d-flex">
                    <input
                      :disabled="modelprivileges === 'View'"
                      class="form-control"
                      type="file"
                      @change="helloButton"
                    />
                  </div>
                </div>

                <!-- checkbox -->
                <div
                  v-if="modeltype === 'checkbox'"
                  :class="modelradioclass"
                >
                  <input
                    :disabled="modelprivileges === 'View' || fromArchive === 'true'"
                    type="checkbox"
                    :id="modelelement.fieldName"
                    :name="modelelement.fieldName"
                    v-model="modelvalue"
                  />
                  <span class="ml-2">{{ modelelement.label }}</span>
                </div>
                <span v-if="modeltype === 'checkbox'" class="errormsg radioerror">
                  {{ errormsg[modelname] }}
                </span>

                <!-- comments -->
                <label class="col-md-2 col-form-label my-1">
                  {{ $t?.('navigations.comments') || 'Comments' }}
                </label>
                <div class="col-md-10 my-1">
                  <textarea class="form-control" v-model="modelcomments" />
                </div>

                <!-- actions -->
                <label class="col-md-2 col-form-label my-1"></label>
                <div
                  v-if="roleprivileges.includes('Data Verification Validate')"
                  class="col-md-4 my-1"
                >
                  <button
                    type="button"
                    class="btn btn-block btn-query btn-outline"
                    @click.prevent="saveaudit('Validated', modeltype)"
                  >
                    {{ $t?.('navigations.validate') || 'Validate' }}
                  </button>
                </div>
                <div
                  v-if="roleprivileges.includes('Data Verification Incorrect')"
                  class="col-md-4 my-1"
                >
                  <button
                    type="button"
                    class="btn btn-block btn btn-outline-warning"
                    @click.prevent="saveaudit('Incorrect', modeltype)"
                  >
                    {{ $t?.('navigations.incorrect') || 'Incorrect' }}
                  </button>
                </div>

                <div
                  v-if="roleprivileges.includes('Data Verification Field query')"
                  class="col-md-1 my-2"
                >
                  <button
                    class="btn btn-rquery ml-1"
                    type="button"
                    @click="gotoraiseQuary('fieldQuery')"
                  >
                    <span class="pointer">
                      {{ $t?.('navigations.field query') || 'Field query' }}
                    </span>
                    <i class="fa fa-question"></i>
                  </button>
                </div>

                <!-- audit table -->
                <div class="col-md-12 my-4">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>{{ $t?.('navigations.value') || 'Value' }}</th>
                          <th>{{ $t?.('navigations.status') || 'Status' }}</th>
                          <th>{{ $t?.('navigations.user') || 'User' }}</th>
                          <th>{{ $t?.('navigations.data source') || 'Data source' }}</th>
                          <th>{{ $t?.('navigations.date') || 'Date' }}</th>
                          <th>{{ $t?.('navigations.time') || 'Time' }}</th>
                          <th>{{ $t?.('navigations.comments') || 'Comments' }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="audits in audit" :key="audits._k">
                          <td class="maximumwidth">{{ audits.newValue }}</td>
                          <td>{{ audits.status }}</td>
                          <td>{{ audits.validatedBy || '' }}</td>
                          <td>{{ audits.dataSource }}</td>
                          <td>{{ audits.validatedDate ? filter(audits.validatedDate) : '' }}</td>
                          <td>{{ audits.validatedTime ? filterTime(audits.validatedTime) : '' }}</td>
                          <td>{{ audits.comment }}</td>
                        </tr>
                        <tr v-if="audit.length === 0">
                          <td colspan="7" class="text-center text-muted">No audit entries</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div><!-- /form-group -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template #footer>
    <!-- optional: keep empty to mimic provided markup -->
  </template>
</customModal>

</template>
<script src="./crfView.js"></script>
<style scoped>
.form-field-card {
    border-left: 3px solid #0d6efd;
    margin-bottom: 0.4rem;
}
.clickable-icon {
  cursor: pointer;
}
.clickable-icon :hover {
  color:#494949;
}
.ibox-footer {
  background-color: #ffffff;
  border-color: #e7eaec;
  border-image: none;
  border-style: none solid solid ;
  border-width: 1px;
  color: inherit;
  padding: 8px 15px 8px 15px;
  min-height: 32px;
  position: relative;
  clear: both;
  width:unset;
  -webkit-border-radius:  0 0 3px 3px;
  -moz-border-radius:  0 0 3px 3px;
  border-radius:0 0 3px 3px;
}
.constheight {
    height: 55px;
}
.headderbg
 {
    background-color: #b2c5f4 !important;
}
.fieldheight
 {
   min-height: 55px;
}
</style>